import ProductListItem from "core/components/ProductListItem";
import { _t } from "core/language";
import { useEffect, useState } from "react";
import { useHistoryMain } from "../hooks";
import SectionSkeleton from "./SectionSkeleton";
import MainNodata from "./NodataComponent";
import { formatDateTime } from "core/utils/helper";
import { ANALYZE_TYPE } from "modules/Ingredients/constant";
import { convertArrayToString } from "modules/Ingredients/components/History/Items";
import { useGoToAiChef } from "modules/AiChef/hooks/aiChef";
import { useCustomNavigate } from "core/hooks/useCustomNavigate";
import { RouterName } from "core/router";
import { useSelector } from "react-redux";

const HistoriesSection = ({ refresh }: any) => {
  const navigate = useCustomNavigate();
  const [paramsHistory, setParamsHistory] = useState({
    refresh: refresh,
  });
  const userInfo = useSelector((state: any) => state.Auth.userInfo);
  useEffect(() => {
    setParamsHistory({
      refresh: refresh,
    });
  }, [refresh]);

  const { goToAiChef } = useGoToAiChef();
  const [histories, loading] = useHistoryMain(paramsHistory);

  const handleClick = (data: any) => {
    console.log(data);
    goToAiChef(data);
  };
  const hasData = histories?.length > 0;

  if ((!hasData && !loading) || !userInfo?.id) {
    return null;
  }

  const handleClickTab = (data: any) => {
    console.log(data);
    navigate(`${RouterName.INGREDIENTS}?tab=history`);
  };

  return (
    <section className={`relative py-[20px] w-full bg-white`}>
      <h1
        className="text-[16px] font-bold text-[#111111] pl-4 flex items-center"
        onClick={() => handleClickTab({})}
      >
        {_t("main.history")}
      </h1>
      <div className="flex flex-col items-start overflow-x-scroll no-scrollbar">
        <div className="flex mt-3.5 gap-2 px-4">
          {loading && !hasData && <SectionSkeleton width={140} height={140} />}
          {(histories || []).map((history: any, index: any) => (
            <div key={index} className="flex flex-col items-start">
              <ProductListItem
                key={index}
                className="w-[140px] h-[140px] mb-0"
                image={history?.files ? history?.files?.[0]?.url?.medium : ""}
                name={""}
                {...history}
                dataItem={history}
                handleClick={handleClick}
              />
              <h2 className="text-[13px] font-bold text-[#111111] mt-3">
                {_t(ANALYZE_TYPE[history.analyze_type])}
              </h2>
              <p className="text-[13px] text-[#333333]">
                {history.analyze_type === "INGREDIENT" &&
                  convertArrayToString(history.response_ingredients, 2)}
                {history.analyze_type === "MEAL" && `${history.analyze_title}`}
              </p>
              <span className="text-[11px] font-medium text-[#777777]">
                {formatDateTime(history.created_at, "YYYY.MM.DD HH:mm")}
              </span>
            </div>
          ))}
        </div>
        <MainNodata
          loading={loading}
          data={histories}
          text={_t("main.no_data")}
        />
      </div>
    </section>
  );
};

export default HistoriesSection;
